import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Kartengenerator", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createBlock(_component_Menubar, {
    model: _ctx.items,
    class: "p-mt-4"
  }, {
    start: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["model"]))
}